/**
 * Created by Udara Prabath
 * Date: 10/20/2020
 * Using: IntelliJ IDEA
 */

export const FETCH_LECTURE = 'FETCH_LECTURE';